const layout = () => import('../../internal/dashboard/layoutV2.vue')
const resetScreen = () => import('./index.vue')

const resetPasswordRoutes = {
  component: layout,
  children: [
    {
      path: '/update-password',
      name: 'updatePassword',
      meta: {
        title: 'updatePassword',
        requiresAuth: true,
      },
      component: resetScreen,
    },
  ],
}

export default resetPasswordRoutes
